// @flow

import React from "react";
import { compose } from "redux";
import { localize } from "redux-i18n";
import { Button, Modal, ModalBody, ModalHeader, ModalFooter, SchemaForm, Col } from "@components";
import type { NurseDeclinedReason } from "@modules/service/reducer/nurse-declined-reasons/types";
import type { ApprovableContainer } from "@modules/service/types";

import { uiSchema } from "./ui-schema";

type OwnProps = $Exact<{
  editing: boolean,
  reason: ?ApprovableContainer<NurseDeclinedReason>,
  schema: Object,
  onCancel: () => void,
  onSubmit: (payload: { draft: NurseDeclinedReason }) => void,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export class NurseDeclinedReasonsEditModal extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    // Class components needs constructor for accessing the SchemaForm's ref
    this.formRef = React.createRef();
  }

  submitForm = () => {
    this.formRef.current.submit();
  };

  handleSubmit = (formData: Object) => {
    if (formData) {
      let activeTo = this.draft?.activeTo;
      if (!this.draft?.activeTo && !formData.isActive) {
        activeTo = new Date().toISOString();
      }

      if ((this.draft?.activeTo && formData.isActive) || !this.props.editing) {
        activeTo = null;
      }

      const dat = {
        ...formData,
        activeTo: activeTo,
      };
      this.props.onSubmit({ draft: dat });
    }
  };

  get uiSchema() {
    return uiSchema(this.props.t, this.props.editing);
  }

  get draft() {
    return this.props.reason?.content;
  }

  get data() {
    return this.props.editing ? this.draft : {};
  }

  render() {
    return (
      <Modal className="modal-small">
        <ModalHeader className="d-flex justify-content-between" toggle={this.props.onCancel}>
          {this.props.editing
            ? this.props.t("NURSE_DECLINED_REASON_EDIT_TITLE", {
                reasonId: (this.props.reason || {}).id,
              })
            : this.props.t("NURSE_DECLINED_REASON_ADD_TITLE")}
        </ModalHeader>
        <ModalBody className="d-flex justify-content-center align-content-center">
          {this.props.schema ? (
            <Col sm={10}>
              <SchemaForm
                ref={this.formRef}
                className="w-80"
                formData={this.data}
                schema={this.props.schema}
                uiSchema={this.uiSchema}
                onSubmit={this.handleSubmit}
                externalSubmit
              >
                <div className="d-flex justify-content-center" />
              </SchemaForm>
            </Col>
          ) : null}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.props.onCancel}>
            {this.props.t("CANCEL")}
          </Button>
          <Button materialIcon="save" onClick={this.submitForm}>
            {this.props.t("SAVE")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default compose(localize())(NurseDeclinedReasonsEditModal);
